import React from "react";

interface Props {
  label?: string;
}

const Loading: React.FC<Props> = ({ label = "Loading ..." }) => {
  return (
    <div className="p-6 text-center">
      <div className="flex justify-center items-center space-x-2">
        <div className="w-5 h-5 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
        <span className="text-gray-600">{label}</span>
      </div>
    </div>
  );
};

export default Loading;
